import { memo } from 'react';

import { alpha, Backdrop, Box, LinearProgress, useTheme } from '@mui/material';

import MapError from '@/features/offlineSalesOptimizer/components/mapUiStates/MapError';

interface ComparisonMapOverlayProps {
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  onRetry: () => void;
}

const ComparisonMapOverlay = ({
  isLoading,
  isFetching,
  isError,
  onRetry,
}: ComparisonMapOverlayProps) => {
  const theme = useTheme();

  const isOpen = isLoading || isFetching || isError;

  return (
    <Backdrop
      open={isOpen}
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'block',
        backgroundColor: alpha(
          theme.palette.mode === 'light'
            ? theme.palette.common.white
            : theme.palette.common.black,
          0.4
        ),
        backdropFilter: 'blur(1px)',
        zIndex: 2,
      }}
    >
      <Box px={0.5}>
        {(isLoading || isFetching) && (
          <LinearProgress sx={{ color: 'primary.600', borderRadius: 1 }} />
        )}
      </Box>

      {isError && (
        <Box
          display='flex'
          alignItems='center'
          justifyContent='center'
          height='100%'
          px={2}
        >
          <MapError handleReload={onRetry} />
        </Box>
      )}
    </Backdrop>
  );
};

export default memo(ComparisonMapOverlay);
